import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgCommentsIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.2 9.6a3.2 3.2 0 0 1 3.2-3.2h35.2a3.2 3.2 0 0 1 3.2 3.2v19.2a3.2 3.2 0 0 1-3.2 3.2H44.8v12.8a3.2 3.2 0 0 1-3.2 3.2h-6.4v6.4a3.2 3.2 0 0 1-3.2 3.2h-2.45a3.2 3.2 0 0 1-2.459-1.151L20.051 48H6.4a3.2 3.2 0 0 1-3.2-3.2V25.6a3.2 3.2 0 0 1 3.2-3.2h12.8zm0 16H6.4v19.2h13.65a3.2 3.2 0 0 1 2.46 1.151l7.04 8.449H32V48a3.2 3.2 0 0 1 3.2-3.2h6.4v-9.98l-4.691 5.629a3.2 3.2 0 0 1-2.458 1.151H32a3.2 3.2 0 0 1-3.2-3.2V32h-6.4a3.2 3.2 0 0 1-3.2-3.2zm38.4-16H22.4v19.2h6.4A3.2 3.2 0 0 1 32 32v6.4h2.45l7.521-9.024a1.6 1.6 0 0 1 1.23-.576h14.4zM28.8 24v-9.6H32V24zm12.8-9.6V24h-3.2v-9.6zM48 24v-9.6h3.2V24z"
    />
  </svg>
)
export default SvgCommentsIcon
